import React from 'react';
import { Button } from 'carbon-components-react';
import { Popup24 } from '@carbon/icons-react';
import { FormattedMessage } from 'react-intl';
import messages from 'src/apps/envizi-price-estimator/locales/messages';

type WelcomeProps = {
  title: string;
  handleClick: () => void;
};

const Welcome = ({ handleClick }: WelcomeProps) => {
  return (
    <Button
      onClick={handleClick}
      renderIcon={Popup24}
      className="launchBtnMargin"
    >
      <FormattedMessage {...messages.launch_btn_text} />
    </Button>
  );
};

export default Welcome;
